import { render, staticRenderFns } from "./UpdateStockForm.vue?vue&type=template&id=d180b09e"
import script from "./UpdateStockForm.vue?vue&type=script&lang=js"
export * from "./UpdateStockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports